// Guardian AI Admin Service Protocol Definitions
// Subdomain: Security Configuration
// Version: v1

// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none,json_types=true"
// @generated from file guardianai/v1/admin/security_config.proto (package guardianai.v1.admin, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp, TimestampJson } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file guardianai/v1/admin/security_config.proto.
 */
export const file_guardianai_v1_admin_security_config: GenFile = /*@__PURE__*/
  fileDesc("CilndWFyZGlhbmFpL3YxL2FkbWluL3NlY3VyaXR5X2NvbmZpZy5wcm90bxITZ3VhcmRpYW5haS52MS5hZG1pbiKNAgoOU2VjdXJpdHlDb25maWcSDwoHZW5hYmxlZBgBIAEoCBIZChFwcmV2ZW50X2Rldl90b29scxgCIAEoCBIUCgxwcmV2ZW50X2NvcHkYAyABKAgSGwoTcHJldmVudF9yaWdodF9jbGljaxgEIAEoCBIiChpwcmV2ZW50X2tleWJvYXJkX3Nob3J0Y3V0cxgFIAEoCBIXCg9kaXNhYmxlX2NvbnNvbGUYBiABKAgSFAoMZW5jcnlwdF9kYXRhGAcgASgIEhkKEXdoaXRlbGlzdGVkX3BhdGhzGAggAygJEi4KCnVwZGF0ZWRfYXQYCSABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wIhoKGEdldFNlY3VyaXR5Q29uZmlnUmVxdWVzdCJQChlHZXRTZWN1cml0eUNvbmZpZ1Jlc3BvbnNlEjMKBmNvbmZpZxgBIAEoCzIjLmd1YXJkaWFuYWkudjEuYWRtaW4uU2VjdXJpdHlDb25maWci6gEKG1VwZGF0ZVNlY3VyaXR5Q29uZmlnUmVxdWVzdBIPCgdlbmFibGVkGAEgASgIEhkKEXByZXZlbnRfZGV2X3Rvb2xzGAIgASgIEhQKDHByZXZlbnRfY29weRgDIAEoCBIbChNwcmV2ZW50X3JpZ2h0X2NsaWNrGAQgASgIEiIKGnByZXZlbnRfa2V5Ym9hcmRfc2hvcnRjdXRzGAUgASgIEhcKD2Rpc2FibGVfY29uc29sZRgGIAEoCBIUCgxlbmNyeXB0X2RhdGEYByABKAgSGQoRd2hpdGVsaXN0ZWRfcGF0aHMYCCADKAkyhQIKFVNlY3VyaXR5Q29uZmlnU2VydmljZRJyChFHZXRTZWN1cml0eUNvbmZpZxItLmd1YXJkaWFuYWkudjEuYWRtaW4uR2V0U2VjdXJpdHlDb25maWdSZXF1ZXN0Gi4uZ3VhcmRpYW5haS52MS5hZG1pbi5HZXRTZWN1cml0eUNvbmZpZ1Jlc3BvbnNlEngKFFVwZGF0ZVNlY3VyaXR5Q29uZmlnEjAuZ3VhcmRpYW5haS52MS5hZG1pbi5VcGRhdGVTZWN1cml0eUNvbmZpZ1JlcXVlc3QaLi5ndWFyZGlhbmFpLnYxLmFkbWluLkdldFNlY3VyaXR5Q29uZmlnUmVzcG9uc2VCHVobZ3VhcmRpYW5haS92MS9hZG1pbjthZG1pbnYxYgZwcm90bzM", [file_google_protobuf_timestamp]);

/**
 * @generated from message guardianai.v1.admin.SecurityConfig
 */
export type SecurityConfig = Message<"guardianai.v1.admin.SecurityConfig"> & {
  /**
   * @generated from field: bool enabled = 1;
   */
  enabled: boolean;

  /**
   * @generated from field: bool prevent_dev_tools = 2;
   */
  preventDevTools: boolean;

  /**
   * @generated from field: bool prevent_copy = 3;
   */
  preventCopy: boolean;

  /**
   * @generated from field: bool prevent_right_click = 4;
   */
  preventRightClick: boolean;

  /**
   * @generated from field: bool prevent_keyboard_shortcuts = 5;
   */
  preventKeyboardShortcuts: boolean;

  /**
   * @generated from field: bool disable_console = 6;
   */
  disableConsole: boolean;

  /**
   * @generated from field: bool encrypt_data = 7;
   */
  encryptData: boolean;

  /**
   * @generated from field: repeated string whitelisted_paths = 8;
   */
  whitelistedPaths: string[];

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 9;
   */
  updatedAt?: Timestamp;
};

/**
 * @generated from message guardianai.v1.admin.SecurityConfig
 */
export type SecurityConfigJson = {
  /**
   * @generated from field: bool enabled = 1;
   */
  enabled?: boolean;

  /**
   * @generated from field: bool prevent_dev_tools = 2;
   */
  preventDevTools?: boolean;

  /**
   * @generated from field: bool prevent_copy = 3;
   */
  preventCopy?: boolean;

  /**
   * @generated from field: bool prevent_right_click = 4;
   */
  preventRightClick?: boolean;

  /**
   * @generated from field: bool prevent_keyboard_shortcuts = 5;
   */
  preventKeyboardShortcuts?: boolean;

  /**
   * @generated from field: bool disable_console = 6;
   */
  disableConsole?: boolean;

  /**
   * @generated from field: bool encrypt_data = 7;
   */
  encryptData?: boolean;

  /**
   * @generated from field: repeated string whitelisted_paths = 8;
   */
  whitelistedPaths?: string[];

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 9;
   */
  updatedAt?: TimestampJson;
};

/**
 * Describes the message guardianai.v1.admin.SecurityConfig.
 * Use `create(SecurityConfigSchema)` to create a new message.
 */
export const SecurityConfigSchema: GenMessage<SecurityConfig, {jsonType: SecurityConfigJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_admin_security_config, 0);

/**
 * Empty, fetches the singleton
 *
 * @generated from message guardianai.v1.admin.GetSecurityConfigRequest
 */
export type GetSecurityConfigRequest = Message<"guardianai.v1.admin.GetSecurityConfigRequest"> & {
};

/**
 * Empty, fetches the singleton
 *
 * @generated from message guardianai.v1.admin.GetSecurityConfigRequest
 */
export type GetSecurityConfigRequestJson = {
};

/**
 * Describes the message guardianai.v1.admin.GetSecurityConfigRequest.
 * Use `create(GetSecurityConfigRequestSchema)` to create a new message.
 */
export const GetSecurityConfigRequestSchema: GenMessage<GetSecurityConfigRequest, {jsonType: GetSecurityConfigRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_admin_security_config, 1);

/**
 * @generated from message guardianai.v1.admin.GetSecurityConfigResponse
 */
export type GetSecurityConfigResponse = Message<"guardianai.v1.admin.GetSecurityConfigResponse"> & {
  /**
   * @generated from field: guardianai.v1.admin.SecurityConfig config = 1;
   */
  config?: SecurityConfig;
};

/**
 * @generated from message guardianai.v1.admin.GetSecurityConfigResponse
 */
export type GetSecurityConfigResponseJson = {
  /**
   * @generated from field: guardianai.v1.admin.SecurityConfig config = 1;
   */
  config?: SecurityConfigJson;
};

/**
 * Describes the message guardianai.v1.admin.GetSecurityConfigResponse.
 * Use `create(GetSecurityConfigResponseSchema)` to create a new message.
 */
export const GetSecurityConfigResponseSchema: GenMessage<GetSecurityConfigResponse, {jsonType: GetSecurityConfigResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_admin_security_config, 2);

/**
 * @generated from message guardianai.v1.admin.UpdateSecurityConfigRequest
 */
export type UpdateSecurityConfigRequest = Message<"guardianai.v1.admin.UpdateSecurityConfigRequest"> & {
  /**
   * @generated from field: bool enabled = 1;
   */
  enabled: boolean;

  /**
   * @generated from field: bool prevent_dev_tools = 2;
   */
  preventDevTools: boolean;

  /**
   * @generated from field: bool prevent_copy = 3;
   */
  preventCopy: boolean;

  /**
   * @generated from field: bool prevent_right_click = 4;
   */
  preventRightClick: boolean;

  /**
   * @generated from field: bool prevent_keyboard_shortcuts = 5;
   */
  preventKeyboardShortcuts: boolean;

  /**
   * @generated from field: bool disable_console = 6;
   */
  disableConsole: boolean;

  /**
   * @generated from field: bool encrypt_data = 7;
   */
  encryptData: boolean;

  /**
   * @generated from field: repeated string whitelisted_paths = 8;
   */
  whitelistedPaths: string[];
};

/**
 * @generated from message guardianai.v1.admin.UpdateSecurityConfigRequest
 */
export type UpdateSecurityConfigRequestJson = {
  /**
   * @generated from field: bool enabled = 1;
   */
  enabled?: boolean;

  /**
   * @generated from field: bool prevent_dev_tools = 2;
   */
  preventDevTools?: boolean;

  /**
   * @generated from field: bool prevent_copy = 3;
   */
  preventCopy?: boolean;

  /**
   * @generated from field: bool prevent_right_click = 4;
   */
  preventRightClick?: boolean;

  /**
   * @generated from field: bool prevent_keyboard_shortcuts = 5;
   */
  preventKeyboardShortcuts?: boolean;

  /**
   * @generated from field: bool disable_console = 6;
   */
  disableConsole?: boolean;

  /**
   * @generated from field: bool encrypt_data = 7;
   */
  encryptData?: boolean;

  /**
   * @generated from field: repeated string whitelisted_paths = 8;
   */
  whitelistedPaths?: string[];
};

/**
 * Describes the message guardianai.v1.admin.UpdateSecurityConfigRequest.
 * Use `create(UpdateSecurityConfigRequestSchema)` to create a new message.
 */
export const UpdateSecurityConfigRequestSchema: GenMessage<UpdateSecurityConfigRequest, {jsonType: UpdateSecurityConfigRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_admin_security_config, 3);

/**
 * @generated from service guardianai.v1.admin.SecurityConfigService
 */
export const SecurityConfigService: GenService<{
  /**
   * Get the global security configuration (Public/Authenticated)
   *
   * @generated from rpc guardianai.v1.admin.SecurityConfigService.GetSecurityConfig
   */
  getSecurityConfig: {
    methodKind: "unary";
    input: typeof GetSecurityConfigRequestSchema;
    output: typeof GetSecurityConfigResponseSchema;
  },
  /**
   * Update the global security configuration (Admin only)
   *
   * @generated from rpc guardianai.v1.admin.SecurityConfigService.UpdateSecurityConfig
   */
  updateSecurityConfig: {
    methodKind: "unary";
    input: typeof UpdateSecurityConfigRequestSchema;
    output: typeof GetSecurityConfigResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_guardianai_v1_admin_security_config, 0);

